/*
Government Purpose Rights (“GPR”)
Contract No.  W911NF-14-D-0005
Contractor Name:   University of Southern California
Contractor Address:  3720 S. Flower Street, 3rd Floor, Los Angeles, CA 90089-0001
Expiration Date:  Restrictions do not expire, GPR is perpetual
Restrictions Notice/Marking: The Government's rights to use, modify, reproduce, release, perform, display, or disclose this software are restricted by paragraph (b)(2) of the Rights in Noncommercial Computer Software and Noncommercial Computer Software Documentation clause contained in the above identified contract.  No restrictions apply after the expiration date shown above. Any reproduction of the software or portions thereof marked with this legend must also reproduce the markings. (see: DFARS 252.227-7014(f)(2)) 
No Commercial Use: This software shall be used for government purposes only and shall not, without the express written permission of the party whose name appears in the restrictive legend, be used, modified, reproduced, released, performed, or displayed for any commercial purpose or disclosed to a person other than subcontractors, suppliers, or prospective subcontractors or suppliers, who require the software to submit offers for, or perform, government contracts.  Prior to disclosing the software, the Contractor shall require the persons to whom disclosure will be made to complete and sign the non-disclosure agreement at 227.7103-7.  (see DFARS 252.227-7025(b)(2))
*/
import React from "react";
import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { SizeProp } from "@fortawesome/fontawesome-svg-core";

interface FilledBar {
  percentage?: number;
  size?: SizeProp;
  padding?: number;
  animate?: boolean;
  direction?: "row" | "column";
}

const useStyles = makeStyles()(() => ({
  star: {
    paddingRight: "5px",
    justifyContent: "center",
  },
  starEmpty: {
    color: "#AAAAAA",
  },
  starFilled: {
    color: "#FEE502",
  },
}));

const LessonCompletionBar = (props: FilledBar): JSX.Element => {
  const { classes } = useStyles();
  const score = props.percentage || 0;

  return (
    <Box
      data-cy="lesson-card-stars"
      data-test={score}
      component="div"
      sx={{ display: "flex", flexDirection: props.direction || "row" }}
    >
      <FontAwesomeIcon
        icon={faStar}
        size={props.size}
        data-cy="lesson-star"
        data-test={score >= 0.25}
        className={
          props.animate
            ? `${score >= 0.25 ? "starFilled" : "starEmpty"} star1`
            : `${classes.star} ${
                score >= 0.25 ? classes.starFilled : classes.starEmpty
              }`
        }
        style={{ padding: props.padding }}
      />
      <FontAwesomeIcon
        icon={faStar}
        size={props.size}
        data-cy="lesson-star"
        data-test={score >= 0.5}
        className={
          props.animate
            ? `${score >= 0.5 ? "starFilled" : "starEmpty"} star2`
            : `${classes.star} ${
                score >= 0.5 ? classes.starFilled : classes.starEmpty
              }`
        }
        style={{ padding: props.padding }}
      />
      <FontAwesomeIcon
        icon={faStar}
        size={props.size}
        data-cy="lesson-star"
        data-test={score >= 0.75}
        className={
          props.animate
            ? `${score >= 0.75 ? "starFilled" : "starEmpty"} star3`
            : `${classes.star} ${
                score >= 0.75 ? classes.starFilled : classes.starEmpty
              }`
        }
        style={{ padding: props.padding }}
      />
    </Box>
  );
};

export default LessonCompletionBar;
